(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('[data-bab-config]');
    if (!section) return;

    var config = JSON.parse(section.getAttribute('data-bab-config'));
    var sectionEl = section;

    /* ── State ── */
    var state = {
      bundleSize: config.defaultBundleSize,
      selections: {},
      slotOrder: [],
      requireExactFill: config.requireExactFill,
      purchaseType: 'subscribe'
    };

    /* ── DOM refs ── */
    var dom = {
      pills: sectionEl.querySelectorAll('[data-bab-size]'),
      slotsTrack: sectionEl.querySelector('[data-bab-slots-track]'),
      progressFill: sectionEl.querySelector('[data-bab-progress-fill]'),
      progressCurrent: sectionEl.querySelector('[data-bab-progress-current]'),
      progressTotal: sectionEl.querySelector('[data-bab-progress-total]'),
      cta: sectionEl.querySelector('[data-bab-cta]'),
      remaining: sectionEl.querySelector('[data-bab-remaining]'),
      mobileCount: sectionEl.querySelector('[data-bab-mobile-count]'),
      cards: sectionEl.querySelectorAll('[data-bab-product]'),
      radios: sectionEl.querySelectorAll('[data-bab-purchase]'),
      frequencySelect: sectionEl.querySelector('[data-bab-interval]')
    };

    /* ── Helpers ── */
    function totalSelected() {
      var t = 0;
      for (var k in state.selections) t += state.selections[k].qty;
      return t;
    }

    function hasSpace() {
      return totalSelected() < state.bundleSize;
    }

    function formatMoney(cents) {
      return config.moneyFormat
        .replace('{{amount}}', (cents / 100).toFixed(2))
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','));
    }

    /* ── Build flat array of filled items (shared by progress + slots) ── */
    function buildFilledArray() {
      var filled = [];
      for (var i = 0; i < state.slotOrder.length; i++) {
        var vid = state.slotOrder[i];
        if (state.selections[vid] && state.selections[vid].qty > 0) {
          for (var q = 0; q < state.selections[vid].qty; q++) {
            filled.push(state.selections[vid]);
          }
        }
      }
      return filled;
    }

    /* ── Render: Progress bar ── */
    function renderProgress() {
      var count = totalSelected();
      var size = state.bundleSize;

      dom.progressCurrent.textContent = count;
      dom.progressTotal.textContent = size;

      var pct = size > 0 ? (count / size) * 100 : 0;
      if (pct > 100) pct = 100;

      dom.progressFill.style.width = pct + '%';
      dom.progressCurrent.style.left = pct + '%';

      dom.progressTotal.style.display = (count >= size) ? 'none' : '';
    }

    /* ── Render: Slot boxes ── */
    function renderSlots() {
      var track = dom.slotsTrack;
      track.innerHTML = '';

      var filled = buildFilledArray();

      for (var s = 0; s < state.bundleSize; s++) {
        var slot = document.createElement('div');
        slot.className = 'bab-slot';
        slot.setAttribute('data-bab-slot', '');

        if (filled[s]) {
          slot.classList.add('is-filled');

          if (filled[s].image) {
            var img = document.createElement('img');
            img.src = filled[s].image;
            img.alt = filled[s].title;
            img.loading = 'lazy';
            img.className = 'bab-slot__image';
            slot.appendChild(img);
          }

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'bab-slot__remove';
          removeBtn.setAttribute('aria-label', 'Remove ' + filled[s].title);
          removeBtn.textContent = '✕';
          removeBtn.setAttribute('data-bab-slot-remove', s);
          slot.appendChild(removeBtn);
        } else {
          var plus = document.createElement('span');
          plus.className = 'bab-slot__plus';
          plus.textContent = '+';
          slot.appendChild(plus);
        }

        track.appendChild(slot);
      }

      bindSlotRemoveButtons();
    }

    /* ── Slot remove handler ── */
    function removeSlotItem(slotIndex) {
      var filled = buildFilledArray();
      if (!filled[slotIndex]) return;

      var target = filled[slotIndex];
      var vid = null;
      for (var id in state.selections) {
        if (state.selections[id] === target) { vid = id; break; }
      }
      if (!vid) return;

      state.selections[vid].qty--;
      if (state.selections[vid].qty <= 0) {
        delete state.selections[vid];
        state.slotOrder = state.slotOrder.filter(function (id) { return id !== vid; });
      }
      render();
    }

    function bindSlotRemoveButtons() {
      var removeBtns = dom.slotsTrack.querySelectorAll('[data-bab-slot-remove]');
      removeBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          removeSlotItem(parseInt(this.getAttribute('data-bab-slot-remove'), 10));
        });
      });
    }

    /* ── Render: Card controls ── */
    function renderCard(card) {
      var vid = card.getAttribute('data-variant-id');
      var entry = state.selections[vid];
      var qty = entry ? entry.qty : 0;

      var addBtn = card.querySelector('[data-bab-add]');
      var qtyWrap = card.querySelector('[data-bab-qty]');
      var qtyVal = card.querySelector('[data-bab-qty-val]');

      card.classList.toggle('is-active', qty > 0);

      if (qty > 0) {
        addBtn.style.display = 'none';
        qtyWrap.classList.add('is-active');
        qtyVal.textContent = qty;
      } else {
        addBtn.style.display = '';
        qtyWrap.classList.remove('is-active');
        qtyVal.textContent = '0';
      }

      addBtn.disabled = !hasSpace();
      if (!hasSpace()) {
        addBtn.style.opacity = '0.45';
        addBtn.style.cursor = 'not-allowed';
      } else {
        addBtn.style.opacity = '';
        addBtn.style.cursor = '';
      }
    }

    function renderAllCards() {
      dom.cards.forEach(function (c) { renderCard(c); });
    }

    /* ── Render: CTA + mobile bar ── */
    function renderCTA() {
      var total = totalSelected();
      var remaining = state.bundleSize - total;
      var isFull = remaining <= 0;

      if (dom.remaining) {
        dom.remaining.textContent = remaining;
      }

      if (isFull) {
        dom.cta.textContent = (config.ctaCompleteText || 'ADD TO CART').toUpperCase();
        dom.cta.classList.add('bab-cta--filled');
      } else {
        var incLabel = (config.ctaIncompleteText || 'Add {x} More').replace('{x}', '<span data-bab-remaining>' + remaining + '</span>');
        dom.cta.innerHTML = incLabel;
        dom.remaining = dom.cta.querySelector('[data-bab-remaining]');
        dom.cta.classList.remove('bab-cta--filled');
      }

      if (state.requireExactFill) {
        dom.cta.disabled = !isFull;
      } else {
        dom.cta.disabled = total === 0;
      }

      if (dom.mobileCount) {
        dom.mobileCount.textContent = total + '/' + state.bundleSize;
      }

      var mobileBar = sectionEl.querySelector('[data-bab-mobile-bar]');
      if (mobileBar) {
        var mobileLabel = mobileBar.querySelector('.bab-mobile-bar__inner');
        if (mobileLabel) {
          var labelSpans = mobileLabel.querySelectorAll('span:not([data-bab-mobile-count]):not(.bab-mobile-bar__arrow)');
          if (isFull && labelSpans.length >= 2) {
            labelSpans[0].textContent = 'Products Selected.';
            labelSpans[1].textContent = 'Add to Cart';
          } else if (labelSpans.length >= 2) {
            labelSpans[0].textContent = 'Products Selected.';
            labelSpans[1].textContent = 'Add More';
          }
        }
      }
    }

    /* ── Helpers: subtotal (raw base price, no discounts) ── */
    function calcSubtotal() {
      var sum = 0;
      for (var vid in state.selections) {
        sum += state.selections[vid].price * state.selections[vid].qty;
      }
      return sum;
    }

    function getBundleDiscountRate() {
      var bd = config.bundleDiscounts || {};
      var rate = bd[String(state.bundleSize)];
      return (typeof rate === 'number') ? rate / 100 : 0;
    }

    function getSubscriptionDiscountRate() {
      return (config.subscriptionDiscountPercent || 0) / 100;
    }

    /* ── Render: Prices ── */
    function renderPrices() {
      var origOnetime = sectionEl.querySelector('[data-bab-price-original]');
      var priceOnetime = sectionEl.querySelector('[data-bab-price-onetime]');
      var origSub = sectionEl.querySelector('[data-bab-price-original-sub]');
      var priceSub = sectionEl.querySelector('[data-bab-price-subscribe]');

      var count = totalSelected();
      if (count === 0) {
        [origOnetime, priceOnetime, origSub, priceSub].forEach(function (el) {
          if (el) el.textContent = '';
        });
        return;
      }

      var base = calcSubtotal();
      var bundleRate = getBundleDiscountRate();
      var subRate = getSubscriptionDiscountRate();

      var onetimeTotal = Math.round(base * (1 - bundleRate));
      var hasBundleDiscount = bundleRate > 0;

      if (hasBundleDiscount) {
        if (origOnetime) origOnetime.textContent = formatMoney(base);
        if (priceOnetime) priceOnetime.textContent = formatMoney(onetimeTotal);
      } else {
        if (origOnetime) origOnetime.textContent = '';
        if (priceOnetime) priceOnetime.textContent = formatMoney(base);
      }

      var subTotal = Math.round(base * (1 - bundleRate) * (1 - subRate));
      var hasAnySubDiscount = bundleRate > 0 || subRate > 0;

      if (hasAnySubDiscount) {
        if (origSub) origSub.textContent = formatMoney(base);
        if (priceSub) priceSub.textContent = formatMoney(subTotal);
      } else {
        if (origSub) origSub.textContent = '';
        if (priceSub) priceSub.textContent = formatMoney(base);
      }
    }

    /* ── Render: Purchase type UI ── */
    function renderPurchaseType() {
      dom.radios.forEach(function (radio) {
        radio.checked = radio.getAttribute('data-bab-purchase') === state.purchaseType;
      });

      if (dom.frequencySelect) {
        dom.frequencySelect.style.display = state.purchaseType === 'subscribe' ? '' : 'none';
      }
    }

    /* ── Full render pass ── */
    function render() {
      renderProgress();
      renderSlots();
      renderAllCards();
      renderCTA();
      renderPrices();
      renderPurchaseType();
    }

    /* ── Actions ── */
    function addItem(card) {
      if (!hasSpace()) return;
      var vid = card.getAttribute('data-variant-id');

      if (!state.selections[vid]) {
        state.selections[vid] = {
          qty: 0,
          title: card.getAttribute('data-title'),
          image: card.getAttribute('data-image'),
          price: parseInt(card.getAttribute('data-price'), 10)
        };
        state.slotOrder.push(vid);
      }

      state.selections[vid].qty++;
      render();
    }

    function incrementItem(card) {
      if (!hasSpace()) return;
      var vid = card.getAttribute('data-variant-id');
      if (state.selections[vid]) {
        state.selections[vid].qty++;
      }
      render();
    }

    function decrementItem(card) {
      var vid = card.getAttribute('data-variant-id');
      if (!state.selections[vid]) return;

      state.selections[vid].qty--;

      if (state.selections[vid].qty <= 0) {
        delete state.selections[vid];
        state.slotOrder = state.slotOrder.filter(function (id) { return id !== vid; });
      }

      render();
    }

    function changeBundleSize(newSize) {
      state.bundleSize = newSize;

      while (totalSelected() > state.bundleSize) {
        var lastVid = state.slotOrder[state.slotOrder.length - 1];
        if (!lastVid || !state.selections[lastVid]) break;

        state.selections[lastVid].qty--;
        if (state.selections[lastVid].qty <= 0) {
          delete state.selections[lastVid];
          state.slotOrder.pop();
        }
      }

      dom.pills.forEach(function (pill) {
        pill.classList.toggle('is-active', parseInt(pill.getAttribute('data-bab-size'), 10) === newSize);
      });

      render();
    }

    /* ── Event Binding ── */
    dom.pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        changeBundleSize(parseInt(this.getAttribute('data-bab-size'), 10));
      });
    });

    dom.cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-bab-add]');
      var minusBtn = card.querySelector('[data-bab-minus]');
      var plusBtn = card.querySelector('[data-bab-plus]');

      if (addBtn) addBtn.addEventListener('click', function () { addItem(card); });
      if (plusBtn) plusBtn.addEventListener('click', function () { incrementItem(card); });
      if (minusBtn) minusBtn.addEventListener('click', function () { decrementItem(card); });
    });

    dom.radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        state.purchaseType = this.getAttribute('data-bab-purchase');
        render();
      });
    });

    if (dom.frequencySelect) {
      dom.frequencySelect.addEventListener('change', function () {
        render();
      });
    }

    /* ── Add to Cart ── */
    var isSubmitting = false;

    function getSellingPlanForFrequency() {
      if (!dom.frequencySelect) return 0;
      var freq = dom.frequencySelect.value;
      var plans = config.sellingPlans || {};
      return plans[freq] || 0;
    }

    function buildCartItems() {
      var items = [];
      var sellingPlan = (state.purchaseType === 'subscribe') ? getSellingPlanForFrequency() : 0;

      if (state.purchaseType === 'subscribe' && !sellingPlan) {
        console.error('[Build-A-Box] No selling plan configured for frequency: ' + (dom.frequencySelect ? dom.frequencySelect.value : 'unknown') + ' weeks');
        return [];
      }

      for (var vid in state.selections) {
        var entry = state.selections[vid];
        if (entry.qty <= 0) continue;

        var item = {
          id: parseInt(vid, 10),
          quantity: entry.qty
        };

        if (sellingPlan) {
          item.selling_plan = sellingPlan;
        }

        items.push(item);
      }

      return items;
    }

    function setCTALoading(loading) {
      if (loading) {
        dom.cta.setAttribute('data-bab-cta-text', dom.cta.textContent);
        dom.cta.textContent = 'Adding…';
        dom.cta.disabled = true;
        dom.cta.style.opacity = '0.7';
      } else {
        dom.cta.textContent = dom.cta.getAttribute('data-bab-cta-text') || 'ADD TO CART';
        dom.cta.removeAttribute('data-bab-cta-text');
        dom.cta.style.opacity = '';
        renderCTA();
      }
    }

    function setCTAError(message) {
      dom.cta.textContent = message;
      dom.cta.style.opacity = '';
      dom.cta.disabled = false;
      setTimeout(function () { renderCTA(); }, 2500);
    }

    function resetAfterSuccess() {
      state.selections = {};
      state.slotOrder = [];
      render();
    }

    function addToCart() {
      if (isSubmitting) return;
      if (dom.cta.disabled) return;

      var items = buildCartItems();
      if (items.length === 0) {
        if (state.purchaseType === 'subscribe') {
          setCTAError('Missing selling plan');
        }
        return;
      }

      isSubmitting = true;
      setCTALoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          isSubmitting = false;
          setCTALoading(false);
          resetAfterSuccess();
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (window.UpCart && typeof window.UpCart.open === 'function') {
            window.UpCart.open();
          } else if (document.querySelector('upcart-app')) {
            document.dispatchEvent(new CustomEvent('upcart:open'));
          }
        })
        .catch(function (err) {
          isSubmitting = false;
          var msg = (err && err.description) || (err && err.message) || 'Something went wrong';
          setCTAError(msg);
        });
    }

    dom.cta.addEventListener('click', addToCart);

    var mobileBar = sectionEl.querySelector('[data-bab-mobile-bar]');
    if (mobileBar) {
      mobileBar.addEventListener('click', function () {
        if (totalSelected() >= state.bundleSize) addToCart();
      });
    }

    /* ── Init ── */
    render();
  });
})();
